module.exports = __webpack_public_path__ + "img/close-window.6ed33685.svg";